module.exports = __webpack_public_path__ + "img/yt_icon_rgb.9a59817e.png";